/** The floating-sheet recipe shared by the page inset and the dock, so the two can never drift. */
export const SHELL_SHEET = 'rounded-4 bg-bg-content shadow-1 inset-ring-1 inset-ring-border'
